import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles(() => ({
  container: {
    padding: 1,
    height: 90,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    overflow: 'hidden'
  },
  center: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  button: {
    height: '22px',
    minHeight: '22px',
    maxHeight: '22px'
  },
  text: {
    textTransform: 'none',
    fontSize: '0.90rem'
  }
}))
